import { Button, Text, Tooltip } from '@customerio/pluma-components/react';
import plur from 'plur';

import { type Asset } from '@/services/db/asset/entity';

type SelectionActionsProps = {
  checkedAssetIds: Set<string>;
  canDeleteAssets: boolean;
  cannotDeleteCheckedItems: boolean;
  filteredAssets: Asset[];
  onSelectAll: (assets: Asset[]) => void;
  onDeleteCheckedAssets: () => void;
  onClearSelection: () => void;
};

export function SelectionActions({
  checkedAssetIds,
  canDeleteAssets,
  cannotDeleteCheckedItems,
  filteredAssets,
  onSelectAll,
  onDeleteCheckedAssets,
  onClearSelection,
}: SelectionActionsProps) {
  if (checkedAssetIds.size === 0) {
    return null;
  }

  return (
    <>
      <Text size="s" color="subtle">
        {checkedAssetIds.size} {plur('item', checkedAssetIds.size)} selected
      </Text>
      <Button variant="subtle" size="sm" onClick={() => onSelectAll(filteredAssets)}>
        Select all
      </Button>
      <Tooltip
        content={
          cannotDeleteCheckedItems
            ? 'You cannot delete folders with items inside.'
            : canDeleteAssets
            ? ''
            : 'Your user role does not have access to this feature.'
        }
        isDisabled={canDeleteAssets && !cannotDeleteCheckedItems}
        isCustom
      >
        {(context) => (
          <Button
            variant="subtle"
            size="sm"
            isDanger
            isDisabled={!canDeleteAssets || cannotDeleteCheckedItems}
            onClick={onDeleteCheckedAssets}
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
          >
            Delete
          </Button>
        )}
      </Tooltip>
      <Button variant="subtle" size="sm" onClick={onClearSelection}>
        Clear selection
      </Button>
    </>
  );
}
